import { ErrorState, IconTitle, Loading, StatsCard } from '@dec/shared';
import { CurrencyExchange, FileBarGraph } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';

import { useCurrentAccountTaxpayerStats } from '../hooks/useCurrentAccountTaxpayerStats';
import { type CurrentAccountTaxpayerStats } from '../models/CurrentAccount';

interface CurrentAccountTaxpayerStatsCardProps {
  taxpayerId: string;
  col?: number;
}

export const CurrentAccountTaxpayerStatsCard = ({
  taxpayerId,
  col = 6
}: CurrentAccountTaxpayerStatsCardProps) => {
  const { t } = useTranslation();
  const { data: stats, isLoading, error, refetch } = useCurrentAccountTaxpayerStats(taxpayerId);

  return (
    <div className="h-100">
      <div className="card h-100">
        <div className="card-header header-jurisdiction">
          <IconTitle
            title={t('dashboard.currentAccount')}
            icon={FileBarGraph}
            subtitle={t('dashboard.actualSituation')}
          />
        </div>
        <div className="card-body">
          {isLoading && <Loading />}

          {error && <ErrorState onRetry={() => void refetch()} />}

          {!isLoading && !error && (
            <div className="row">
              {(stats ?? []).map((item: CurrentAccountTaxpayerStats) => (
                <div className={`col-12 col-md-${col}`} key={item.accountTypeId}>
                  <StatsCard
                    title={item.accountTypeName}
                    type="number"
                    value={item.balance}
                    icon={CurrencyExchange}
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
